window.VjsUtility = (function(my){
    var self = my.Popup = {};

    //this will hold the instance of the popup
    //this should be like a singleton
    var _popup = null;

    self.init = function (settings) {
        _popup = new Popup();
        _popup.render(settings);
    };

    self.close = function () {
        _popup.close();
    };

    var Popup = function () {};
    Popup.prototype = {
        /**
         *  @desc title of the popup
         */
        title: null,

        /**
         *  @desc content of the popup
         */
        content: null,

        /**
         *  @desc width of the popup
         */
        width: "600px",

        /**
         *  @desc height of the popup
         */
        height: "auto",

        /**
         *  @desc transition type for popup
         *      possible values  [fade, slide-right, slide-top]
         */
        transition: "fade",

        /**
         *  @desc id of popup background
         */
        backgroundId: "#vjs-popup-background",

        /**
         *  @desc classes to add to popup background
         */
        backgroundClasses: null,

        /**
         *  @desc id of popup body
         */
        bodyId: "#vjs-popup-body",

        /**
         *  @desc classes to add to the popup body
         */
        bodyClasses: null,

        /**
         *  @desc content container id
         */
        contentId: "#vjs-popup-content",

        /**
         *  @desc which type of icon for the close icon
         *      possible values
         *      fa = font awesome
         *      all other with be an X
         */
        iconType: "fa",

        /**
         *  @desc should we hide the title bar?
         *       true / false
         */
        hideTitle: false,

        //???
        after: null,
        onRender: null,
        onClose: null,

        /**
         *  @desc popup html
         */
        html: {
            background: function () {
                return "<div class='vjs-popup-background " + (this.backgroundClasses ? this.backgroundClasses : "") + "' id='vjs-popup-background'></div>";
            },
            body: function () {
                var titleBar = ''
                    + '<div class="vjs-popup-title-container">'
                    + '	<div class="vjs-popup-title" id="vjs-popup-title"></div>'
                    + '	<div id="vjs-popup-notification" class="vjs-popup-notification"></div>'
                    + '</div>';

                var compiledBody = ""
                    + '<div class="vjs-popup-body ' + (this.transition ? this.transition : '') +  ' '  // add the transition class
                    + (this.bodyClasses ? this.bodyClasses : '') + '" id="vjs-popup-body">'        // add the custom body classes
                    + (this.hideTitle ? '' : titleBar)
                    +   '<div class="vjs-popup-close" id="vjs-popup-close" tabindex="0" aria-label="close popup">' + this.html.icon.call(this) + '</div>'
                    +   '<div class="vjs-popup-content" id="vjs-popup-content"></div>'
                    + "</div>";

                return compiledBody;
            },
            icon: function () {
                switch (this.iconType) {
                    case "fa":
                        return "<i class='fa fa-times vjs-popup-close-icon'></i>";
                    default:
                        return "<span class='vjs-popup-close-icon'>X</span>";
                }
            }
        },

        render: function (settings) {
            //set any settings passed in
            this.title               = settings.title                ? settings.title               : this.title;
            this.content             = settings.content              ? settings.content             : this.content;
            this.width               = settings.width                ? settings.width               : this.width;
            this.height              = settings.height               ? settings.height              : this.height;
            this.transition          = settings.transition           ? settings.transition          : this.transition;
            this.backgroundClasses   = settings.backgroundClasses    ? settings.backgroundClasses   : this.backgroundClasses;
            this.bodyClasses         = settings.bodyClasses          ? settings.bodyClasses         : this.bodyClasses;
            this.iconType            = settings.iconType             ? settings.iconType            : this.iconType;
            this.hideTitle           = settings.hideTitle            ? settings.hideTitle           : this.hideTitle;
            this.after               = settings.after                ? settings.after               : this.after;

            //not using these yet
            //or ever will
            this.onClose             = settings.onClose              ? settings.onClose             : this.onClose;
            this.onRender            = settings.onRender             ? settings.onRender            : this.onRender;

            //test if popup already exists
            this._testIfPopupExists();

            //add the background html to the page
            $("body")
                .addClass("body-stop-scroll")
                .append(this.html.background.call(this));

            // $(".vjs-header-container, .vjs-main-container, .vjs-footer-container").addClass("blur");
            var popup = $(this.html.body.call(this));
            popup.find("#vjs-popup-title").html(this.title);
            popup.find("#vjs-popup-content").html(this.content);
            popup.appendTo(this.backgroundId);

            $(".vjs-popup-close").focus();

            if (typeof this.onRender === "function") {
                this.onRender();
            }

            //now we build the body of the popup using the view class on the utility object

            //possible settings to send
            //  this.settings.url
            //  this.settings.templateUrl
            //  this.settings.data

            var PopupBody = my.View.extend({
                parent: this.contentId,
                templateUrl: (settings.templateUrl)
                                ? settings.templateUrl
                                : null,
                dataUrl:     (settings.dataUrl)
                                ? settings.dataUrl
                                : null,
                events: {
                    "click #vjs-popup-close": "_close",
                    "keyup #vjs-popup-body":  "_keypressClose"
                },
                after: function () {
                    if(typeof this.after === "function") this.after.call(this);
                }.bind(this),
                _close: function () {
                    this.close();
                }.bind(this),
                _keypressClose: function (e) {
                    var keyPressed = (e.keyCode ? e.keyCode : e.which);

                    if (keyPressed == 27) {
                        this.close();
                    }
                }.bind(this)
            });

            //now figure out if we should use the fetch or render function
            var pbody = (new PopupBody());
            if(settings.dataUrl){
                pbody.fetch();
            }else{
                pbody.render(
                    (settings.data ? settings.data : null)
                );
            }
        },

        /**
         *  @desc this will check if popup exists, and if so it will remove it
         *      only one popup allowed at a time
         */
        _testIfPopupExists: function () {
            var $popup = $(this.backgroundId)
            if($popup.is(":visible")){
                $popup.detach().remove();
            }
        },

        close: function (e) {
            //see if need to return focus to another element
            if (this.focusReturn) {
                $(this.focusReturn).focus();
            }

            //see if they have a callback
            if(typeof this.closeCallBack === "function"){
                this.closeCallBack();
            }

            $("body").removeClass("body-stop-scroll");
            $("#vjs-popup-background")
                .fadeOut(function () {
                    $(this).detach().remove();
                });

            if (typeof this.onClose === "function"){
                this.onClose();
            }
        }
    };

    return my;
}(window.VjsUtility || {}));
